import React from 'react';

export const NoProduct = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--no-product';
  color = color || '#0076CC';

  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M2.527 11.5996C2.55935 11.5403 2.62151 11.5034 2.68905 11.5034H21.3049C21.3753 11.5034 21.4396 11.5435 21.4706 11.6067L22.9462 14.6109C23.0065 14.7336 22.9172 14.877 22.7805 14.877H13.7411C13.6706 14.877 13.6063 14.8368 13.5753 14.7736L12.0734 11.7077C12.0059 11.5698 11.8094 11.5698 11.7418 11.7077L10.2399 14.7736C10.2089 14.8368 10.1446 14.877 10.0742 14.877H1.04947C0.909322 14.877 0.820282 14.7269 0.887422 14.6039L2.527 11.5996Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16.025L12 21.695"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4154 16.73V20.86C21.4154 21.1729 21.1319 21.4731 20.6274 21.6944C20.123 21.9157 19.4387 22.04 18.7253 22.04H5.2747C4.56124 22.04 3.877 21.9157 3.37251 21.6944C2.86802 21.4731 2.58459 21.1729 2.58459 20.86V16.73"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="11.9385" cy="5.15382" r="4.44616" stroke={color} strokeWidth="1.2" />
      <path
        d="M10.2161 6.71582L13.501 3.97322"
        stroke={color}
        strokeWidth="0.940003"
        strokeLinecap="round"
      />
      <path
        d="M10.3169 3.97327L13.5011 6.83908"
        stroke={color}
        strokeWidth="0.940003"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default NoProduct;
